























































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop } from 'vue-property-decorator'
import { FundingSource } from '@/types/Payments'
import { verifyFundingSource } from '@/services/payments'
import CurrencyInput from '@/components/inputs/CurrencyInput.vue'

@Component({
  components: {
    CurrencyInput,
  },
})
export default class VerifyFundingSourceDialog extends Vue {

  @Prop({ default: false }) readonly opened!: boolean
  @Prop(Object) readonly fundingSource!: FundingSource

  loading = false
  isValid = false

  form = {
    amount1: 0,
    amount2: 0,
  }
  rules = {
    amount: [
      (v: number) => !!v || 'Amount is required',
      (v: number) => v > 0 || 'Amount is invalid',
      (v: number) => v <= .1 || 'Amount will be no more than 10 cents',
    ]
  }

  closeDialog() {
    this.$emit('update:opened', false)
  }

  async verifyFundingSource() {
    this.loading = true
    try {
      await verifyFundingSource(this.$store, {
        ...this.form,
        fundingSourceUrl: this.fundingSource._links.self.href
      })
      this.closeDialog()
    }
    finally {
      this.loading = false 
    }
  }
}
